import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
} from "@sttedra_ui/framework";

import DataSourcesApiResponseModel from "./data-sources.api-response-model.js";
import DataSourcesApiRequestModel from "./data-sources.api-request-model.js";

// #region Globals
const { base } = useAxios();
const timeout = 5000;
// #endregion

// #region Public functions
async function dataSourcesList(searchParams = {}) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = `/DataSource/list`;

    const { data: response } = await base.post(url, searchModel, {
      timeout,
    });

    const { data: originalData, pageSize, pageIndex, totalResults } = response;

    const data = originalData.map((u) => new DataSourcesApiResponseModel(u));

    return {
      data,
      pageSize,
      pageIndex,
      totalResults,
    };
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

async function dataSourcesListAll(searchParams = {}) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = `/DataSource/listAll`;

    const response = await base.get(url, searchModel, {
      timeout,
    });

    const data = response.data.map((u) => new DataSourcesApiResponseModel(u));

    return data;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

async function dataSourcesCreate(params = {}) {
  try {
    const dataSourceModel = new DataSourcesApiRequestModel(params);

    useDeleteNulls(dataSourceModel);

    const url = `/DataSource/addDataSource`;

    const response = await base.post(url, dataSourceModel, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

async function dataSourcesUpdate(idFuente, params = {}) {
  try {
    const dataSourceModel = new DataSourcesApiRequestModel(params);

    useDeleteNulls(dataSourceModel);

    const url = `/DataSource/${idFuente}/updateDataSource`;

    const response = await base.put(url, dataSourceModel, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

async function dataSourcesDelete(id) {
  try {
    const url = `/DataSource/${id}/deleteDataSource`;

    const response = await base.delete(url, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

// Get all database types
async function dataSourcesDatabaseTypes() {
  try {
    const url = `/DataSource/dataDbType/listAll`;

    // Make the request
    const response = await base.get(url, {
      timeout,
    });

    return response.data;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

// Check the datasource
async function dataSourcesCheckService(params = {}) {
  try {
    const url = `/DataSource/CheckDatasourceService`;

    // Make the request
    const response = await base.post(url, params, {
      timeout,
    });

    return response;
  } catch (err) {
    return false;
  }
}

// Check the query
async function dataSourceCheckQueryService(params = {}) {
  try {
    const url = `/DataSource/CheckQueryService`;

    // Make the request
    const response = await base.post(url, params, {
      timeout,
    });

    return response;
  } catch (err) {
    return false;
  }
}
// #endregion

// #region Private functions
// #endregion

export {
  dataSourcesList,
  dataSourcesListAll,
  dataSourcesCreate,
  dataSourcesUpdate,
  dataSourcesDelete,
  dataSourcesCheckService,
  dataSourcesDatabaseTypes,
  dataSourceCheckQueryService,
};
